var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	8481: () => (loadSingleton("default", "@pershing/utils/mfe", false, () => (__webpack_require__.e(7542).then(() => (() => (__webpack_require__(27542))))))),
	27126: () => (loadSingleton("default", "@pershing/px-ui-cdk", false, () => (__webpack_require__.e(7528).then(() => (() => (__webpack_require__(75147))))))),
	27520: () => (loadSingleton("default", "@angular/common", false, () => (__webpack_require__.e(6316).then(() => (() => (__webpack_require__(13935))))))),
	29646: () => (loadSingleton("default", "@angular/core/rxjs-interop", false, () => (__webpack_require__.e(6693).then(() => (() => (__webpack_require__(49074))))))),
	30273: () => (loadSingleton("default", "@angular/platform-browser", false, () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(80436))))))),
	47754: () => (loadSingleton("default", "@angular/core", false, () => (__webpack_require__.e(9148).then(() => (() => (__webpack_require__(99148))))))),
	49405: () => (loadSingleton("default", "@angular-architects/module-federation", false, () => (__webpack_require__.e(7081).then(() => (() => (__webpack_require__(67081))))))),
	55780: () => (loadSingleton("default", "@pershing/shell-comms", false, () => (__webpack_require__.e(7715).then(() => (() => (__webpack_require__(87715))))))),
	57241: () => (loadSingleton("default", "@pershing/utils/date-range", false, () => (__webpack_require__.e(6944).then(() => (() => (__webpack_require__(66944))))))),
	60913: () => (loadSingleton("default", "@pershing/utils/methods", false, () => (__webpack_require__.e(5870).then(() => (() => (__webpack_require__(85870))))))),
	66708: () => (loadSingleton("default", "@angular/common/http", false, () => (__webpack_require__.e(831).then(() => (() => (__webpack_require__(73212))))))),
	70719: () => (loadSingleton("default", "rxjs/operators", false, () => (__webpack_require__.e(3620).then(() => (() => (__webpack_require__(23620))))))),
	73552: () => (loadSingleton("default", "@angular/cdk/layout", false, () => (__webpack_require__.e(7912).then(() => (() => (__webpack_require__(87912))))))),
	77815: () => (loadSingleton("default", "@pershing/utils/operators", false, () => (__webpack_require__.e(4083).then(() => (() => (__webpack_require__(54083))))))),
	80588: () => (loadSingleton("default", "@angular/router", false, () => (__webpack_require__.e(2224).then(() => (() => (__webpack_require__(22224))))))),
	92572: () => (loadSingleton("default", "@angular/cdk/dialog", false, () => (__webpack_require__.e(3482).then(() => (() => (__webpack_require__(93482))))))),
	93122: () => (loadSingleton("default", "@angular/platform-browser/animations", false, () => (__webpack_require__.e(3835).then(() => (() => (__webpack_require__(43835))))))),
	95283: () => (loadSingleton("default", "rxjs", false, () => (__webpack_require__.e(1340).then(() => (() => (__webpack_require__(31340))))))),
	99626: () => (loadSingleton("default", "@angular/forms", false, () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(34456))))))),
	11886: () => (loadSingleton("default", "@angular/core/primitives/di", false, () => (() => (__webpack_require__(52867))))),
	78840: () => (loadSingleton("default", "@angular/core/primitives/signals", false, () => (__webpack_require__.e(8070).then(() => (() => (__webpack_require__(85689))))))),
	44678: () => (loadSingleton("default", "@angular/animations/browser", false, () => (__webpack_require__.e(8581).then(() => (() => (__webpack_require__(80962))))))),
	9732: () => (loadSingleton("default", "@angular/cdk/portal", false, () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(9168))))))),
	27766: () => (loadSingleton("default", "@angular/cdk/scrolling", false, () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(79975))))))),
	38844: () => (loadSingleton("default", "@angular/cdk/keycodes", false, () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(74879))))))),
	41589: () => (loadSingleton("default", "ag-grid-angular", false, () => (__webpack_require__.e(7291).then(() => (() => (__webpack_require__(27291))))))),
	43404: () => (loadSingleton("default", "@angular/cdk/a11y", false, () => (__webpack_require__.e(4508).then(() => (() => (__webpack_require__(72127))))))),
	56428: () => (loadSingleton("default", "@angular/cdk/overlay", false, () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(81570))))))),
	57304: () => (loadSingleton("default", "@angular/cdk/platform", false, () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(17699))))))),
	64690: () => (loadSingleton("default", "@angular/cdk/stepper", false, () => (__webpack_require__.e(6366).then(() => (() => (__webpack_require__(63985))))))),
	66045: () => (loadSingleton("default", "ag-grid-enterprise", false, () => (__webpack_require__.e(9834).then(() => (() => (__webpack_require__(69834))))))),
	72348: () => (loadSingleton("default", "@angular/cdk/table", false, () => (__webpack_require__.e(9408).then(() => (() => (__webpack_require__(17027))))))),
	87392: () => (loadSingleton("default", "@angular/cdk/bidi", false, () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(63680))))))),
	96943: () => (loadSingleton("default", "ag-grid-community", false, () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(72176))))))),
	92947: () => (loadSingleton("default", "@pershing/utils/spinner", false, () => (__webpack_require__.e(880).then(() => (() => (__webpack_require__(58499)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"96": [
		29646,
		47754,
		66708,
		95283
	],
	"436": [
		27520,
		47754,
		66708
	],
	"831": [
		70719,
		95283
	],
	"962": [
		47754
	],
	"1101": [
		27520,
		47754,
		70719,
		95283
	],
	"1570": [
		27520,
		47754,
		70719,
		95283
	],
	"2075": [
		70719,
		95283
	],
	"2127": [
		27520,
		47754,
		70719,
		95283
	],
	"3212": [
		47754,
		70719,
		95283
	],
	"3680": [
		27520,
		47754
	],
	"3835": [
		44678
	],
	"3935": [
		47754,
		95283
	],
	"3985": [
		27520,
		47754,
		70719,
		95283,
		99626
	],
	"4456": [
		27520,
		47754,
		70719,
		95283
	],
	"4563": [
		27126,
		27520,
		47754,
		99626
	],
	"5147": [
		9732,
		27520,
		27766,
		30273,
		38844,
		41589,
		43404,
		47754,
		56428,
		57304,
		64690,
		66045,
		70719,
		72348,
		80588,
		87392,
		95283,
		96943,
		99626
	],
	"5161": [
		27126,
		27520,
		29646,
		47754,
		92947,
		95283
	],
	"5531": [
		27520,
		47754,
		70719,
		95283
	],
	"6216": [
		27520,
		44678,
		47754
	],
	"6316": [
		95283
	],
	"6464": [
		70719,
		95283
	],
	"6693": [
		70719
	],
	"6787": [
		27520,
		47754
	],
	"6920": [
		8481,
		27126,
		27520,
		29646,
		30273,
		47754,
		49405,
		55780,
		57241,
		60913,
		66708,
		70719,
		73552,
		77815,
		80588,
		92572,
		93122,
		95283,
		99626
	],
	"7027": [
		27520,
		47754,
		70719,
		95283
	],
	"7453": [
		96943
	],
	"7528": [
		9732,
		27766,
		30273,
		38844,
		41589,
		43404,
		56428,
		57304,
		64690,
		66045,
		70719,
		72348,
		80588,
		87392,
		95283,
		96943,
		99626
	],
	"7542": [
		92947
	],
	"7699": [
		27520,
		47754
	],
	"8055": [
		66708
	],
	"8499": [
		27126,
		27520,
		29646,
		47754,
		95283
	],
	"9074": [
		47754,
		70719,
		95283
	],
	"9148": [
		11886,
		70719,
		78840,
		95283
	],
	"9672": [
		47754,
		96943
	],
	"9843": [
		27520,
		30273,
		47754,
		70719,
		95283
	],
	"9975": [
		27520,
		47754,
		70719,
		95283
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}